import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../lib/i18n";
import { OPEN_CONSENT_EVENT } from "./CookieConsent";

export const Footer = ({ contacts }) => {
  const { t, lang } = useLang();
  const c = contacts || {};
  return (
    <footer data-testid="site-footer" className="relative grain" style={{ background: "#11110F" }}>
      <div className="max-w-[1600px] mx-auto px-5 md:px-10 pt-24 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 md:gap-8">
          <div className="md:col-span-1">
            <div className="flex items-center gap-3">
              <img src="/brand/argali_emblem_ru_v2.png" alt="Логотип АРГАЛИ" width="543" height="501" className="h-12 w-auto" />
              <span className="font-serif text-3xl tracking-[0.22em] text-argali-ivory">АРГАЛИ</span>
            </div>
            <p className="eyebrow mt-4">{t("positioning")}</p>
          </div>

          <div>
            <p className="eyebrow-muted mb-4 eyebrow">{lang === "ru" ? "Навигация" : "Navigate"}</p>
            <ul className="space-y-2.5 text-sm text-argali-sandstone/80">
              <li><Link to="/excursions" className="hover:text-argali-gold transition-colors">{t("nav_excursions")}</Link></li>
              <li><Link to="/map" className="hover:text-argali-gold transition-colors">{t("nav_map")}</Link></li>
              <li><Link to="/places" className="hover:text-argali-gold transition-colors">{t("nav_places")}</Link></li>
              <li><Link to="/guide" className="hover:text-argali-gold transition-colors">{t("nav_guide")}</Link></li>
              <li><Link to="/reviews" className="hover:text-argali-gold transition-colors">{t("nav_reviews")}</Link></li>
              <li><Link to="/faq" className="hover:text-argali-gold transition-colors">FAQ</Link></li>
            </ul>
          </div>

          <div>
            <p className="eyebrow-muted mb-4 eyebrow">{lang === "ru" ? "Правовое" : "Legal"}</p>
            <ul className="space-y-2.5 text-sm text-argali-sandstone/80">
              <li><Link to="/terms" className="hover:text-argali-gold transition-colors">{lang === "ru" ? "Условия оказания услуг" : "Terms of service"}</Link></li>
              <li><Link to="/privacy" className="hover:text-argali-gold transition-colors">{lang === "ru" ? "Политика обработки данных" : "Personal data policy"}</Link></li>
              <li><Link to="/personal-data-consent" className="hover:text-argali-gold transition-colors">{lang === "ru" ? "Согласие на обработку данных" : "Data processing consent"}</Link></li>
              <li><button type="button" onClick={() => window.dispatchEvent(new Event(OPEN_CONSENT_EVENT))} className="hover:text-argali-gold transition-colors text-left">{lang === "ru" ? "Настройки cookie" : "Cookie settings"}</button></li>
              <li><Link to="/credits" className="hover:text-argali-gold transition-colors">{lang === "ru" ? "Фото и лицензии" : "Photo credits"}</Link></li>
              <li><Link to="/altai" className="hover:text-argali-gold transition-colors">{t("nav_altai")}</Link></li>
              <li><Link to="/custom-tour" className="hover:text-argali-gold transition-colors">{t("cta_custom")}</Link></li>
            </ul>
          </div>

          <div>
            <p className="eyebrow-muted mb-4 eyebrow">{t("nav_contacts")}</p>
            <ul className="space-y-2.5 text-sm text-argali-sandstone/80">
              {c.phone && <li><a href={`tel:${c.phone}`} className="hover:text-argali-gold transition-colors">{c.phone}</a></li>}
              {c.max && <li><a href="https://max.ru/u/f9LHodD0cOKIQ3CkI05ZDHFq3wnbhdSpV1OrgE68OxpVwSEtfmM8rQLNqBE" target="_blank" rel="noreferrer" className="hover:text-argali-gold transition-colors">MAX</a></li>}
              {c.telegram_dm && <li><a href={c.telegram_dm} target="_blank" rel="noreferrer" className="hover:text-argali-gold transition-colors">Telegram</a></li>}
              {c.telegram_channel && <li><a href={c.telegram_channel} target="_blank" rel="noreferrer" className="hover:text-argali-gold transition-colors">{lang === "ru" ? "Telegram-канал" : "Telegram channel"}</a></li>}
              {c.whatsapp && <li><a href={c.whatsapp} target="_blank" rel="noreferrer" className="hover:text-argali-gold transition-colors">WhatsApp</a></li>}
              {c.instagram && <li><a href={c.instagram} target="_blank" rel="noreferrer" className="hover:text-argali-gold transition-colors">Instagram</a></li>}
              {c.youtube && <li><a href={c.youtube} target="_blank" rel="noreferrer" className="hover:text-argali-gold transition-colors">YouTube</a></li>}
              {c.email && <li><a href={`mailto:${c.email}`} className="hover:text-argali-gold transition-colors">{c.email}</a></li>}
            </ul>
            <div className="mt-6">
              <p className="text-[0.6rem] uppercase tracking-[0.16em] text-argali-sandstone/45 mb-2">{lang === "ru" ? "Рейтинг в Яндексе" : "Yandex rating"}</p>
              <a href="https://yandex.ru/maps/org/argali/149759078052/" target="_blank" rel="noreferrer" className="text-sm text-argali-sandstone/80 hover:text-argali-gold transition-colors">{lang === "ru" ? "Открыть карточку АРГАЛИ" : "Open АРГАЛИ listing"}</a>
            </div>
          </div>
        </div>

        <div className="hair-line my-14" />

        <Link to="/excursions" className="block group">
          <h2 className="display display-lg text-argali-ivory leading-[0.9]">
            {t("see_altai")}
          </h2>
        </Link>

        <div className="mt-16 flex flex-col md:flex-row justify-between gap-4 text-xs text-argali-sandstone/50">
          <p>© {new Date().getFullYear()} АРГАЛИ · {c.org_name || "ИП Кушерова Арина Нурлановна"} · ИНН {c.inn || "041104306600"} · ОГРНИП {c.ogrnip || "326040000003380"}</p>
          <p>{lang === "ru" ? "Республика Алтай, Россия" : "Altai Republic, Russia"}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;